module.exports = __webpack_public_path__ + "img/hon_02.1aa94dc4.jpg";